<template>
  <checkout-panel
    index="4"
    title="Review items and accept terms"
    :editing="true"
  >
    <template v-if="componentState.items.loading" #secondary>
      <loading-component></loading-component>
    </template>
    <template v-else-if="componentState.items.error" #secondary>
      <error-component></error-component>
    </template>
    <template v-else #secondary>
      <checkout-item
        v-for="(shoppingCartItem, i) in items"
        :key="'cart_item_' + i"
        :shopping-cart-item="shoppingCartItem"
      ></checkout-item>
    </template>
  </checkout-panel>
</template>

<script>
import { mapGetters } from "vuex";
import store from "../../../store/stores";
import CheckoutPanel from "../layout/CheckoutPanel.vue";
import CheckoutItem from "./cart/CheckoutItem.vue";
import LoadingComponent from "./elements/LoadingComponent.vue";
import ErrorComponent from "./elements/ErrorComponent.vue";

export default {
  store,
  components: {
    CheckoutItem,
    CheckoutPanel,
    LoadingComponent,
    ErrorComponent,
  },
  computed: {
    ...mapGetters({
      items: "checkout/cartItems",
      componentState: "checkout/componentState",
    }),
  },
};
</script>
